module.exports = __webpack_public_path__ + "img/nengajo-ura.5791083c.jpg";